document.addEventListener('DOMContentLoaded', function () {

    const buttons = document.querySelectorAll('.g-btn');
    const cards = document.querySelectorAll('.package-card');
    const targetSection = document.querySelector('.packages-section-inner');

    function filterCards(filter, scroll = false) {

        cards.forEach(card => {

            // Show all cards
            if (filter === 'all') {
                card.style.display = '';
                return;
            }

            const isMatch = card.dataset[filter] === 'true';

            if (isMatch) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }

        });

        // Scroll only on button click
        if (scroll && targetSection) {

            setTimeout(() => {

                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });

            }, 100);

        }
    }

    // Default show all
    filterCards('all');

    buttons.forEach(button => {

        button.addEventListener('click', function () {

            buttons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            let filter = this.dataset.need;

            // kebab-case to camelCase
            filter = filter.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

            // Filter with scroll
            filterCards(filter, true);

        });

    });

});
